<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Meus Dados</h5>
                <hr>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-4">
                        <label>Nome</label>
                        <InputText v-model="usuario.nome"  readonly/>				
                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-4">
                        <label>E-mail</label>
                        <InputText v-model="usuario.email"  readonly/>
                    </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-4">
                        <label>Senha</label>
                        <Password v-model.trim="senha" :feedback="false"/>				
                    </div>                           
                </div>
                <div class="p-fluid p-formgrid p-grid">                           
                    <div class="p-field p-col-12 p-md-4">
                        <label>Repetir senha</label>
                        <Password v-model.trim="repetirSenha" :feedback="false"/>
                    </div>
                </div>
                <Button label="Atualizar Senha" icon="pi pi-check" class="p-mt-3" @click="alterarSenha"/>                
            </div>
        </div>
    </div>
</template>

<script>
import RevendedorService from '@/service/RevendedorService.js'; 
import { exibirMensagem, exibirMensagemSis } from '@/global';
import { mapGetters } from 'vuex';

export default {
    revendedorService: null,
    data() {
        return {
            usuario: {},           
            senha: '',
            repetirSenha: '',
        }
    },
    methods: {
        ...mapGetters('sessao', ['getUsuario']),       
        alterarSenha() {
            if(this.senha.length < 8 || this.repetirSenha.length < 8) {
                exibirMensagemSis(this, 'A senha deverá ser formada por 8 caracteres, números e letras. No minímo 1 maiúsculo e 1 minúsuculo.', true);
                return;
            } else if(this.senha != this.repetirSenha) {
                exibirMensagemSis(this, 'Não são iguais', true);
                return;
            }
            let requisicao = {
                senha: this.senha,
                senhaIgual: this.repetirSenha,
                revendedor: { id: this.usuario.id }
            };           
            this.revendedorService.alterarSenha(requisicao)
				.then(resp => {                   
                    this.senha = '';
                    this.repetirSenha = '';
                    exibirMensagem(this, resp);	
                })
                .catch(erro => {exibirMensagem(this, erro)});            
        }
    },
    created() {
        this.usuario = this.getUsuario();
        this.revendedorService = new RevendedorService();
    },   
}
</script>

<style>

</style>